import React from 'react';
import { velocityStatusLabel, velocityStatusTone } from '../../utils/velocity';

const TONES = {
  success:  'bg-green-50 text-green-700 border-green-200',
  progress: 'bg-blue-50 text-blue-700 border-blue-200',
  warn:     'bg-amber-50 text-amber-700 border-amber-200',
  danger:   'bg-red-50 text-red-700 border-red-200',
  muted:    'bg-gray-50 text-gray-600 border-gray-200',
};

const DARK_TONES = {
  success:  'bg-green-500/10 text-green-300 border-green-500/20',
  progress: 'bg-blue-500/10 text-blue-300 border-blue-500/20',
  warn:     'bg-amber-500/10 text-amber-300 border-amber-500/20',
  danger:   'bg-red-500/10 text-red-300 border-red-500/20',
  muted:    'bg-white/5 text-gray-400 border-white/10',
};

/** Velocity shipment status — text backend doc se, rang tone se. */
const VelocityStatusPill = ({ status, isDark = false, className = '' }) => {
  const tone = velocityStatusTone(status);
  const classes = (isDark ? DARK_TONES : TONES)[tone] || (isDark ? DARK_TONES.muted : TONES.muted);
  return (
    <span className={`inline-flex items-center px-2.5 py-1 rounded-full border text-[11px] font-bold uppercase tracking-wide ${classes} ${className}`}>
      {velocityStatusLabel(status)}
    </span>
  );
};

export default VelocityStatusPill;
